import React from "react";
import { Helmet } from "react-helmet-async";

/**
 * Wrapper component that adds noindex meta tag to private routes.
 * Wrapping dashboard/private routes prevents Google from wasting crawl budget.
 */
const NoIndexWrapper = ({ children }) => {
  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      {children}
    </>
  );
};

export default NoIndexWrapper;
